import { render, staticRenderFns } from "./SettlementIbanDetailsModal.vue?vue&type=template&id=72115f78&scoped=true"
import script from "./SettlementIbanDetailsModal.vue?vue&type=script&lang=js"
export * from "./SettlementIbanDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./SettlementIbanDetailsModal.vue?vue&type=style&index=0&id=72115f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72115f78",
  null
  
)

export default component.exports